function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable no-console */
/**
 * profile.js usage
 *
 * -- create a profile object and give it a name for the section you are testing
 *
 * `const updateProfile = profile('Update code');`
 *
 * --- call updateProfile.end() at the end of the section you are testing:
 *
 * `updateProfile.end()`
 *
 * at some point after your testing, call printResults();
 *
 * `printResults()`
 *
 */

const moment = require('moment-timezone');
const formatDuration = msIn => {
  let ms = msIn;
  if (ms < 0) {
    ms = -ms;
  }
  const seconds = ms / 1000;
  return `${seconds.toFixed(2)}`;
};

// keep this in for printing out the stack hierarchy.
// eslint-disable-next-line no-unused-vars
const nSpaces = numSpaces => {
  let result = '';
  for (let i = 0; i < numSpaces; i += 1) {
    result += ' ';
  }
  return result;
};

// global.truqc is injected by ipad app
let profiling = global.truqc && global.truqc.env && global.truqc.env.PROFILE_BEHAVIORS || process && process.env && process.env.PROFILE_BEHAVIORS || false;

// eslint-disable-next-line no-return-assign
const setProfiling = val => profiling = val;
let results = {};
let currentStack = [];

// return recursion if name is ANYWHERE in stack.
const isRecursive = name => currentStack.some(stack => name === stack);
const startMark = (longName, name) => {
  const now = moment().format('x');
  let result = results[name];
  if (result === undefined) {
    result = {
      name,
      longNames: [longName],
      num: 0,
      duration: 0,
      // keep total count of all recursive calls.
      recursiveCalls: 0,
      errors: 0
    };
  }
  results[name] = result;
  return {
    longName,
    name,
    startTime: now,
    recursive: isRecursive(name)
  };
};
const endErrorMark = (name, duration, longName) => {
  console.warn(`\n\nDetected a profile exit that skipped "${name}".  Try looking in ${longName} for any returns or thrown errors that might have skipped this profile.end() call.  Current stack: ${currentStack.join('.')}\n\n`);
  const result = results[name];
  result.errors += 1;
  result.num += 1;
  result.duration += duration;
  if (!result.longNames.includes(longName)) {
    result.longNames.push(longName);
  }
};

// mutates the mark!
const endMark = mark => {
  const {
    name,
    longName,
    recursive
  } = mark;
  const now = moment().format('x');
  // eslint-disable-next-line no-param-reassign
  mark.endTime = now;
  const duration = now - mark.startTime;
  const result = results[name];
  result.num += 1;
  if (!result.longNames.includes(longName)) {
    result.longNames.push(longName);
  }

  // look for recursion...
  if (recursive) {
    // increment the number of total recursive calls.
    result.recursiveCalls += 1;
    // console.log(`${nSpaces(currentStack.length)}
    // ${name} <- recursive pop calls(${result.recursiveCalls}) `);

    // if we are still in recursion, don't pop the stack
    // and dont add duration.  just return out of here.
    return;
  }
  result.duration += duration;

  // something went wrong.  We need to pop until we find this name
  // console.log(`${nSpaces(currentStack.length)} ${name} <- popping ${currentStack.join('.')}`);
  let popped = currentStack.pop();
  while (name !== popped && currentStack.length > 0) {
    endErrorMark(popped, duration, currentStack.join('.'));
    popped = currentStack.pop();
  }
};
const clearResults = () => {
  results = {};
  currentStack = [];
};
const sortDuration = (a, b) => {
  if (a.duration > b.duration) {
    return -1;
  }
  if (a.duration < b.duration) {
    return 1;
  }
  return 0;
};
const pads = (x, len, z = ' ') => (x.substring(0, len) + Array(len).fill(z).join('')).slice(0, len);
const processResult = (oneResult, top, firstColumnWidth) => {
  const {
    duration: totalDuration
  } = top;
  const {
    duration,
    num,
    name,
    longNames
  } = oneResult;
  const perIteration = duration / num;
  const percentOfTotal = duration / totalDuration * 100 || 0;
  let spaces = '';
  longNames[0].split('.').forEach(() => {
    spaces += ' ';
  });
  const recursionStr = oneResult.recursiveCalls > 0 ? `${oneResult.recursiveCalls} recursive calls ` : '';
  const namesStr = longNames.join(', ');
  const nameStr = spaces + name;
  const percentStr = `${percentOfTotal.toFixed(0)}%`;
  const durationStr = `${formatDuration(duration)}s`;
  const iterationsStr = `${num}x`;
  const perStr = `${formatDuration(perIteration)}s`;
  return _objectSpread(_objectSpread({}, oneResult), {}, {
    perIteration,
    percentOfTotal,
    print: `${pads(nameStr, firstColumnWidth)} ${pads(percentStr, 8)} ${pads(durationStr, 8)} ${pads(iterationsStr, 8)} ${pads(perStr, 8)} ${namesStr} ${pads(recursionStr, 8)}`
  });
};
const printResults = (reset = false, minPercentDuration = 1) => {
  if (profiling === false) {
    return '';
  }
  const filterMinimums = oneResult => oneResult.percentOfTotal >= minPercentDuration;
  let resultArray = Object.values(results).sort(sortDuration);
  if (resultArray.length > 0) {
    const topResult = resultArray[0];
    console.log(`total ${formatDuration(topResult.duration)}s`);
    let firstColumnWidth = 20;
    resultArray.forEach(oneResult => {
      if (oneResult.name.length + 2 > firstColumnWidth) {
        firstColumnWidth = oneResult.name.length + 2;
      }
    });
    resultArray = resultArray.map(oneResult => processResult(oneResult, topResult, firstColumnWidth));
    resultArray = resultArray.filter(filterMinimums);
    const joinedResults = resultArray.map(one => one.print).join('\n');
    const titles = `${pads('method name', firstColumnWidth)} ${pads('%/total', 8)} ${pads('secs', 8)} ${pads('iters', 8)} ${pads('secs/per', 8)} ${pads('parent', 20)} ${pads('recursion', 10)}`;
    console.log(titles);
    console.log(pads('', 120, '_'));
    console.log(`${joinedResults}`);
    if (reset) {
      clearResults();
    }
    return resultArray;
  }
  return '';
};

/* create a profile instance to track a section of code */
const profile = nameOfCodeSection => {
  if (profiling === false) {
    return {
      end: () => {}
    };
  }
  const longName = currentStack.join('.');
  const mark = startMark(longName, nameOfCodeSection);
  if (!mark.recursive) {
    // console.log(`${nSpaces(currentStack.length)} ${nameOfCodeSection} -> start `);
    // only add to stack if we are not recursing.
    currentStack.push(nameOfCodeSection);
    // } else {
    //   console.log(`${nSpaces(currentStack.length)} ${nameOfCodeSection} -> recursive ${longName}`);
  }
  const end = () => endMark(mark, currentStack);
  return {
    end
  };
};
exports.clearResults = clearResults;
exports.profile = profile;
exports.printResults = printResults;
exports.setProfiling = setProfiling;